/**
 * Blob Download
 *
 * When making an API request to fetch a file, use this to convert the fetched file to a downloadable file.
 * Used if the API is processing a file and returns a response in plain text.
 * This utility converts a blob object, creates an object URL, creates a temporary anchor link to it
 * then triggers a click to the anchor link to begin the file download.
 *
 * @param blob
 * @param fileName
 */
export const blobDownload = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([blob]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  if (link && link.parentNode) {
    link.parentNode.removeChild(link)
  }
}
